import React, { useEffect, useState, useRef } from 'react'
import Modal from './commons/Modal'
import { FiCheck } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { BuyNowButton } from './BuyNowButton';

export const CartModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const cart = useSelector((state) => state.cart);
    const { cartItems } = cart;
    const [product, setProduct] = useState(null);
  
    // lưu độ dài cũ của cart
    const prevLength = useRef(cartItems.length);
  
    useEffect(() => {
      // nếu tăng số lượng (so với lần trước) thì mới mở modal
      if (cartItems.length > prevLength.current) {
        setIsOpen(true);
        setProduct(cartItems[cartItems.length - 1]);
      }
      // cập nhật lại prevLength
      prevLength.current = cartItems.length;
    }, [cartItems.length]);

    return (
        <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
            {/* Header */}
            <div className="flex items-center gap-2 mb-4">
                <FiCheck className="text-green-600" size={20} />
                <span className="text-sm text-gray-700">Sản phẩm đã được thêm vào giỏ hàng của bạn</span>
            </div>

            {/* Product info */}
            <div className="flex items-center gap-4 mb-4">
                <img
                    src={product?.image?.url}
                    alt={product?.name}
                    className="w-16 h-16 object-contain border rounded"
                />
                <p className="font-medium text-gray-800 text-sm">{product?.name}</p>
            </div>

            <div className='flex justify-center items-center w-full py-2 px-4 gap-4'>
                    <Link to={"/cart"} className='bg-[--color-button-3] w-auto px-6 py-2 rounded-full text-white text-sm font-bold 
                    hover:bg-[--color-button-2] hover:text-black transition-all duration-200
                ' onClick={()=>setIsOpen(false)}>Xem giỏ hàng</Link>
                   <BuyNowButton className={"!m-0 !px-6"} onClick={()=>setIsOpen(false)}/>
                </div>
                <button
                onClick={() => setIsOpen(false)}
                className="block text-sm text-gray-600 hover:underline text-center w-full"
            >
                Tiếp tục mua sắm
            </button>
        </Modal>
    )
}
